import { avlStatusValues, supplierRoleStatusValues } from '@standandforce/api-contract';
import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
export const SupplierTableFilterSchema = z.object({
  ...dataGridSearchFields,
  freeText: z.string().optional(),
  // 初期表示はACTIVEタブ。
  supplierStatusIn: z.array(z.enum(supplierRoleStatusValues)).default(['ACTIVE']),
  avlStatusIn: z.array(z.enum(avlStatusValues)).optional()
});
export type SupplierTableFilterSchema = z.infer<typeof SupplierTableFilterSchema>;